const $ = window.jQuery;

export const initializeAOS = (overrides) => {
  const defaults = {
    delay: 0,
    duration: 0,
    offset: 0,
    threshold: 0,
  };

  const options = { ...defaults, ...overrides };

  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $(entry.target).addClass('aos-animate');
      } else if (entry.boundingClientRect.y > 0) {
        $(entry.target).removeClass('aos-animate');
      }
    });
  };

  $('[data-aos]').each(function () {
    const threshold = parseFloat(
      $(this).attr('data-aos-threshold') ?? options.threshold,
      10,
    );

    const offset =
      -1 * parseInt($(this).attr('data-aos-offset') ?? options.offset, 10);

    const delay = parseInt($(this).attr('data-aos-delay') ?? options.delay, 10);

    const duration = parseInt(
      $(this).attr('data-aos-duration') ?? options.duration,
      10,
    );

    $(this).css('transition-duration', `${duration}ms`);
    if (delay > 0) {
      $(this).css('transition-delay', `${delay}ms`);
    }

    if ($(this).is('[data-aos-custom-trigger]')) {
      return true;
    }

    const observer = new IntersectionObserver(handleIntersect, {
      rootMargin: `0px 0px ${offset}px 0px`,
      threshold,
    });
    observer.observe(this);
  });
};
